import type { LucideIcon } from 'lucide-react';
import { cn } from '../../lib/utils';

interface DetailCardProps {
  title: string;
  icon: LucideIcon;
  children: React.ReactNode;
  className?: string;
}

export default function DetailCard({ title, icon: Icon, children, className }: DetailCardProps) {
  return (
    <div className={cn('bg-white border border-stone-mid rounded-xl overflow-hidden', className)}>
      <div className="flex items-center gap-2.5 px-5 py-3.5 border-b border-stone-mid bg-stone-bg">
        <Icon size={16} className="text-sage flex-shrink-0" />
        <h3 className="text-sm font-semibold text-ink-dark">{title}</h3>
      </div>
      <div className="px-5 py-4">{children}</div>
    </div>
  );
}

interface FieldRowProps {
  label: string;
  value: React.ReactNode;
  mono?: boolean;
  /** Aggancio per i test E2E: la riga sparisce quando il valore è vuoto. */
  testid?: string;
}

export function FieldRow({ label, value, mono, testid }: FieldRowProps) {
  if (value == null || value === '' || value === false) return null;
  return (
    <div className="flex gap-4 py-1.5 border-b border-stone-mid last:border-0" data-testid={testid}>
      <dt className="text-xs text-ink-soft min-w-[140px] pt-0.5 flex-shrink-0">{label}</dt>
      <dd className={cn('text-sm text-ink-dark flex-1', mono && 'font-mono text-xs')}>{value}</dd>
    </div>
  );
}
